module.exports = __webpack_public_path__ + "static/media/emme-home-3.6cace7dc.jpg";